import { EMPTY_LIST } from '../../../../../constants/common'

export function getAISuggestAvailableSuggestions({ excludeIds, suggestions }) {
  if (!suggestions) {
    return EMPTY_LIST
  }

  if (!excludeIds || excludeIds.length === 0) {
    return suggestions
  }

  return suggestions.filter(
    suggestion => !excludeIds.includes(suggestion.request_id)
  )
}

export function getAISuggestSelectionItem({ suggestion, tableItems }) {
  const tableItem = tableItems?.items?.find(
    item => item.id === suggestion.request_id
  )

  return (
    tableItem || {
      archived: suggestion.archived,
      id: suggestion.request_id,
      request_no: suggestion.request_no,
      title: suggestion.title,
    }
  )
}
